<h1 mat-dialog-title>AGGIUNGI SEDE<mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon></h1>
<div class="form-container">
  <form class="details-form">
    <mat-form-field class="half-width margin-right">
      <mat-label>Id Sede *</mat-label>
      <input matInput type="number" placeholder="Id Sede" value="{{sede.idSede}}"
             [(ngModel)]="sede.idSede" (input)="validateIdField()" name="id">
      <div *ngIf="invaildId" class="text-red">L'id sede non deve superare i 15 caratteri.</div>
    </mat-form-field>

    <mat-form-field class="half-width">
      <mat-label>Descrizione *</mat-label>
      <input matInput placeholder="Descrizione" value="{{sede.descrizione}}"
             [(ngModel)]="sede.descrizione" name="descrizione">
    </mat-form-field>

    <mat-form-field class="half-width margin-right">
      <mat-label>Indirizzo *</mat-label>
      <input matInput placeholder="Indirizzo" value="{{sede.indirizzo}}"
             [(ngModel)]="sede.indirizzo" name="indirizzo">
    </mat-form-field>

    <mat-form-field class="half-width">
      <mat-label>CAP *</mat-label>
      <input matInput type="number" placeholder="CAP" value="{{sede.cap}}"
             [(ngModel)]="sede.cap" name="cap">
    </mat-form-field>

    <div class="full-width">
      <div class="half-width margin-right">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Provincia *</mat-label>
          <mat-select (selectionChange)="getComuni(sede.cmbProvincia.id)" name="provincia" [(ngModel)]="sede.cmbProvincia">
            <mat-option *ngFor="let item of listaProvince" [value]="item">
              {{item.descrizione}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="half-width" *ngIf="listaComuni && listaComuni.length > 0">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Comune *</mat-label>
          <mat-select name="comune" [(ngModel)]="sede.cmbComune">
            <mat-option *ngFor="let item of listaComuni" [value]="item">
              {{item.descrizione}}
            </mat-option>
          </mat-select>

        </mat-form-field>

      </div>

    </div>
    <div class="full-width">
      <div class="half-width margin-right">
        <mat-form-field class="full-width">
          <mat-label>Tel</mat-label>
          <input class="custom-input" matInput placeholder="Telefono" value="{{telefono}}"
                 [(ngModel)]="telefono" name="telefono">
          <mat-icon class="input-icon" (click)="addTel(telefono)">add</mat-icon>
        </mat-form-field>
        <mat-list role="list">
          <mat-list-item *ngFor="let tel of sede.listaTelefoni; index as i" role="listitem">
            <strong class="left">Tel {{i+1}}:</strong>&nbsp; <span
            class="grey fixed-width">{{tel.descrizione}}</span>
            <mat-icon class="cancel-icon" (click)="removeTel(i)">cancel</mat-icon>
          </mat-list-item>
        </mat-list>
      </div>
      <div class="half-width">
        <mat-form-field class="full-width">
          <mat-label>Fax</mat-label>
          <input class="custom-input" matInput placeholder="Fax" value="{{fax}}" [(ngModel)]="fax" name="fax">
          <mat-icon class="input-icon" (click)="addFax(fax)">add</mat-icon>
        </mat-form-field>
        <mat-list role="list">
          <mat-list-item *ngFor="let fax of sede.listaFax; index as i" role="listitem">
            <strong class="left">Fax {{i+1}}:</strong>&nbsp; <span
            class="grey fixed-width">{{fax.descrizione}}</span>
            <mat-icon class="cancel-icon" (click)="removeFax(i)">cancel</mat-icon></mat-list-item>
        </mat-list>
      </div>

    </div>
    <div class="full-width">
      <div class="half-width margin-right">
        <mat-form-field class="full-width">
          <mat-label>Email</mat-label>
          <input class="custom-input" matInput placeholder="Email" value="{{email}}" [(ngModel)]="email"
                 name="email">
          <mat-icon class="input-icon" (click)="addEmail(email)">add</mat-icon>
        </mat-form-field>
        <mat-list role="list">
          <mat-list-item *ngFor="let email of sede.listaEmail; index as i" role="listitem">
            <strong class="left">Email {{i+1}}:</strong>&nbsp; <span
            class="grey fixed-width">{{email.descrizione}}</span>
            <mat-icon class="cancel-icon" (click)="removeEmail(i)">cancel</mat-icon>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
    <div class="half-width">
      <mat-label><strong>Attiva *</strong></mat-label>
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                       [(ngModel)]="sede.flAttivo" [value]="sede.flAttivo" name="flAttivo"
                       (change)="changeFlAttivo($event)">
        <mat-radio-button class="example-radio-button" value="1">
          Si
        </mat-radio-button>
        <mat-radio-button class="example-radio-button" value="0">
          No
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </form>
</div>
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Annulla
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" (click)="handleSave()" [disabled]="saveIsDisabled()">
    <mat-icon>save</mat-icon>Salva
  </button>
</div>
